import {
  type ResolvedEvent,
  type ResolvedNotFoundEvent,
  type ResolvedOrdinaryEvent,
} from '@hedepy/common/schemas/modules/event/cart'

export const isResolvedNotFoundEvent = (event: ResolvedEvent): event is ResolvedNotFoundEvent =>
  !event.isAvailable && event.notAvailableErrors[0]?.type === 'EVENT_NOT_FOUND'

export const isResolvedOrdinaryEvent = (event: ResolvedEvent): event is ResolvedOrdinaryEvent =>
  !isResolvedNotFoundEvent(event)

export const isAllCoveredByB2B = (events?: ResolvedEvent[]): boolean => {
  if (!events) return false

  return events
    .filter(isResolvedOrdinaryEvent)
    .every((event) => event.discountedBy && event.discountedBy.type === 'b2b')
}

export const isAllCoveredBySubscription = (events?: ResolvedEvent[]): boolean => {
  if (!events) return false

  return events
    .filter(isResolvedOrdinaryEvent)
    .every((event) => event.discountedBy && event.discountedBy.type === 'subscription')
}

export const isAllCoveredByVoucher = (events?: ResolvedEvent[]): boolean => {
  if (!events) return false

  return events
    .filter(isResolvedOrdinaryEvent)
    .every(
      (event) =>
        event.discountedBy && event.discountedBy.type === 'voucher' && event.discountedBy.voucherType === 'event',
    )
}

export const isAllCoveredByFreeIntroSession = (events?: ResolvedEvent[]): boolean => {
  if (!events) return false

  return events
    .filter(isResolvedOrdinaryEvent)
    .every((event) => event.discountedBy && event.discountedBy.type === 'freeIntroSession')
}
